export const CATEGORIAS_GASTO = [
  { value: 'combustible', label: 'Combustible', color: '#F59E0B' },
  { value: 'mantenimiento', label: 'Mantenimiento', color: '#6B7280' },
  { value: 'packaging', label: 'Packaging', color: '#3B82F6' },
  { value: 'insumos', label: 'Insumos', color: '#8B5CF6' },
  { value: 'articulos_marketing', label: 'Artículos de Marketing', color: '#EC4899' },
  { value: 'anuncios', label: 'Anuncios', color: '#EF4444' },
  { value: 'publicidad', label: 'Publicidad', color: '#F59E0B' },
  { value: 'diseno', label: 'Diseño', color: '#8B5CF6' },
  { value: 'seo_sem', label: 'SEO/SEM', color: '#3B82F6' },
  { value: 'seguros', label: 'Seguros', color: '#22C55E' },
  { value: 'impuestos', label: 'Impuestos', color: '#EF4444' },
  { value: 'servicios_bancarios', label: 'Servicios Bancarios', color: '#14B8A6' },
  { value: 'fletes', label: 'Fletes', color: '#F59E0B' },
  { value: 'seguros_envio', label: 'Seguros de Envío', color: '#3B82F6' },
  { value: 'gastos_varios', label: 'Gastos Varios', color: '#6B7280' },
  { value: 'viaticos', label: 'Viáticos', color: '#EC4899' },
  { value: 'capacitacion', label: 'Capacitación', color: '#8B5CF6' },
];

export const METODOS_PAGO = [
  { value: 'efectivo', label: 'Efectivo' },
  { value: 'transferencia', label: 'Transferencia' },
  { value: 'tarjeta', label: 'Tarjeta' },
  { value: 'cheque', label: 'Cheque' },
  { value: 'otro', label: 'Otro' },
];

export interface Gasto {
  id: number;
  numeroGasto: string;
  categoria: string;
  concepto: string;
  descripcion: string | null;
  monto: number;
  fecha: string;
  metodoPago: string;
  comprobante: string | null;
  pdfUrl: string | null;
  observaciones: string | null;
  usuarioCreador: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateGastoDto {
  categoria: string;
  concepto: string;
  descripcion?: string | null;
  monto: number;
  fecha?: string;
  metodoPago?: string;
  comprobante?: string | null;
  pdfUrl?: string | null;
  observaciones?: string | null;
}

export interface GastoStats {
  total: number;
  totalMes: number;
  totalHoy: number;
  porCategoria: Array<{ categoria: string; monto: number }>;
  porMetodoPago: Array<{ metodo: string; monto: number }>;
}